import * as React from "react";
function SvgArrowsInvert(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
        d="M19 11V1H9M1 19L18 2M13 21v10h10M31 13L14 30"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgArrowsInvert);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
